import { Moon, Sun, Monitor } from "lucide-react";
import { useTheme } from "@/components/theme-provider";
import { Button } from "@/components/ui/button";

const themes = [
  { value: "light" as const, icon: Sun, label: "Light" },
  { value: "dark" as const, icon: Moon, label: "Dark" },
  { value: "system" as const, icon: Monitor, label: "System" },
];

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  const cycleTheme = () => {
    const currentIndex = themes.findIndex((t) => t.value === theme);
    const nextIndex = (currentIndex + 1) % themes.length;
    setTheme(themes[nextIndex].value);
  };

  const currentTheme = themes.find((t) => t.value === theme);
  const Icon = currentTheme?.icon || Sun;

  return (
    <Button
      variant="outline"
      size="icon"
      onClick={cycleTheme}
      className="h-10 w-10"
      aria-label={`Switch to ${themes[(themes.findIndex((t) => t.value === theme) + 1) % themes.length].label} mode`}
      title={`Current: ${currentTheme?.label || "Light"}`}
    >
      <Icon className="h-[1.2rem] w-[1.2rem] transition-all" />
    </Button>
  );
}
